import { createReducer, on } from "@ngrx/store";

import { DashboardState } from "../interfaces/dashboard-state.interface";
import {
  loadBlockUser,
  loadBlockUserFailure,
  loadBlockUserSuccess,
  loadResetBlockUser,
  loadUnblockUser,
  loadUnblockUserFailure,
  loadUnblockUserSuccess,
  loadDeleteUser,
  loadDeleteUserSuccess,
  loadResetErrorDeleteUser,
  loadDeleteUserFailure
} from "./actions/dashboard.actions";
import { initialState } from "./dashboard.state";

export const dashboardReducer = createReducer(
  initialState,
  on(loadResetBlockUser, () => Object.assign({}, initialState)),
  on(
    loadBlockUser,
    (state, { payload }): DashboardState => ({
      ...state,
      blockUserFeature: {
        payload,
        response: null,
        error: null,
        isLoading: true,
      },
    }),
  ),
  on(
    loadUnblockUser,
    (state, { payload }): DashboardState => ({
      ...state,
      unblockUserFeature: {
        payload,
        response: null,
        error: null,
        isLoading: true,
      },
    }),
  ),
  on(
    loadBlockUserSuccess,
    (state, { response }): DashboardState => ({
      ...state,
      blockUserFeature: {
        ...state.blockUserFeature,
        response,
        isLoading: false,
      },
    }),
  ),
  on(
    loadUnblockUserSuccess,
    (state, { response }): DashboardState => ({
      ...state,
      unblockUserFeature: {
        ...state.blockUserFeature,
        response,
        isLoading: false,
      },
    }),
  ),
  on(
    loadBlockUserFailure,
    (state, { error }): DashboardState => ({
      ...state,
      blockUserFeature: {
        ...state.blockUserFeature,
        error,
        isLoading: false,
      },
    }),
  ),
  on(
    loadUnblockUserFailure,
    (state, { error }): DashboardState => ({
      ...state,
      unblockUserFeature: {
        ...state.blockUserFeature,
        error,
        isLoading: false,
      },
    }),
  ),
  on(
    loadDeleteUser,
    (state, { logon }): DashboardState => ({
      ...state,
      deleteUserFeature: {
        selectedLogon: logon
      }
    }),
  ),
  on(
    loadDeleteUserSuccess,
    (state, { success }): DashboardState => ({
      ...state,
      deleteUserFeature: {
        error: null,
        success,
        selectedLogon: state.deleteUserFeature.selectedLogon
      },
    }),
  ),  
  on(
    loadDeleteUserFailure,
    (state, { logon, error }): DashboardState => ({
      ...state,
      deleteUserFeature: {
        selectedLogon: logon,
        success: false,
        error,
      },
    }),
  ),
  on(loadResetErrorDeleteUser, (state) => ({
    ...state,
    deleteUserFeature: {
      selectedLogon: null,
      error: null,
      success: false
    },
  })),  
);
